export default {
  webBaseURL: process.env.MIX_APP_URL,

  auth0Config: {
    domain: "dev-6u-3fb22.auth0.com",
    clientID: "MmsLOH7Ncrh7PKTcyHYKZggfH7RrxeL8",
    // make sure this line is contains the port: 8080
    redirectUri: "http://localhost:8080/callback",
    // we will use the api/v2/ to access the user information as payload
    audience: "https://dev-6u-3fb22.auth0.com/api/v2/",
    responseType: "token id_token",
    scope: "openid profile"
  }
};
export const AppSettings = {
  TabletAppSettings: "TabletAppSettings",
  MobileAppSettings: "MobileAppSettings"
};
export const BusinessSettings = {
  Locales: "Locales",
  Logo: "Logo",
  PrimaryColor: "PrimaryColor",
  AccentColor: "AccentColor",
  TextColor: "TextColor",

  TimeZone: "TimeZone",
  Address: "Address",

  GeneralDiscount: "GeneralDiscount",
  ExtraCharge: "ExtraCharge",
  PreviewPrices: "PreviewPrices",

  Website: "Website",
  Facebook: "Facebook",
  Instagram: "Instagram",
  X: "X",
  ContactPhone: "ContactPhone",
  Whatsapp: "Whatsapp",
  Linkedin: "Linkedin",
  Youtube: "Youtube",
  Snapchat: "Snapchat",

  DineIn: "DineIn",
  Delivery: "Delivery",
  SelfPickUp: "SelfPickUp",
  CarPickup: "CarPickup",
  Currency: "Currency"
};
export const BranchSettings = {
  Locales: "Locales",
  Address: "Address",

  Whatsapp: "Whatsapp",
  ContactPhone: "ContactPhone",
  PreviewPrices: "PreviewPrices",

  DineIn: "DineIn",
  Delivery: "Delivery",
  SelfPickUp: "SelfPickUp",
  CarPickup: "CarPickup",

  EnableOrdering: "EnableOrdering",
  CartVisible: "CartVisible"
};

export const TabletAppSettings = {
  CoverScreen: "CoverScreen",
  CategoriesView: "CategoriesView",
  ItemsListView: "ItemsListView",
  ItemView: "ItemView",
  AboutUsVisible: "AboutUsVisible",
  PassKey: "PassKey",

  EnableOrdering: "EnableOrdering",
  CartVisible: "CartVisible",
  PreviewPrices: "PreviewPrices"
};

export const MobileAppSettings = {
  CoverScreen: "CoverScreen",
  HeaderBackground: "HeaderBackground",
  CategoriesView: "CategoriesView",
  ItemsListView: "ItemsListView",
  ItemView: "ItemView",
  AboutUsVisible: "AboutUsVisible",

  DisableOrdering: "DisableOrdering",
  HideCart: "HideCart",
  HidePrices: "HidePrices",
  RandomSorting: "RandomSorting",
  MenuLayout: "MenuLayout",

  EnableReservationTill: "EnableReservationTill",
  PayCash: "PayCash",
  PayOnline: "PayOnline",
};
export const UserPreferences = {
  ReceiveOrderNotifications: "ReceiveOrderNotifications"
};
export const UserSettings = {
  name: "name",
  email: "email",
  phone: "phone",
  password: "password",
  password_confirmation: "password_confirmation",
  email_verified: "email_verified",
  media: "media",
  profile_photo_url: "profile_photo_url"
};

export const TabletCategoriesViewOptions = [
  "list-view",
  "horizontal-slide",
  "grid-sm",
  "grid-lg"
];

export const TabletItemsListViewOptions = [
  "list-view",
  "horizontal-slide",
  "grid-sm",
  "grid-lg"
];

export const MobileMenuLayoutOptions = ["full-menu", "categorized-menu"];

export const MobileCategoriesViewOptions = ["list-view", "grid-view"];

export const MobileItemsListViewOptions = ["list-view", "grid-view"];

export const MenuTypes = {
  subscription: "subscription",
  normal: "normal"
};

export const BusinessTypes = {
  restaurant: "restaurant",
  salon: "salon",
  hotel: "hotel",
  chalet: "chalet"
};

export const ReservationStatuses = {
  pending: "pending",
  completed: "completed",
  canceled: "canceled"
};

export const StatusOptions = {
  pending: "pending",
  accepted: "accepted",
  rejected: "rejected",
  ready: "ready",
  delivered: "delivered"
};

export const CategorySettings = {
  item_images_dimensions: "items_images_dimensions",
  item_images_fitting: "items_images_fitting"
};


export const ACTIONS = {
  READ: 'read',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete'
};

export const PERMISSIONS = {
  INVOICES: 'invoices',
  USERS: 'users',
  BUSINESS: 'business',
  MENU: 'menu',
  MENUS: 'menus',
  BRANCHES: 'branches',
  ROLES: 'roles',
  HOLIDAYS: 'holidays',
  CATEGORIES: 'categories',
  ITEMS: 'items',
  RESERVATIONS: 'reservations',
  SERVICES: 'services',
  ORDERS: 'orders',
  FLOORS: 'floors',
  TABLES: 'tables',
  SETTINGS: 'settings'
};
